import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { AuthProvider, useAuth } from '../lib/auth.js'
import { ThemeProvider } from '../shell/ThemeProvider.js'
import { SignedOutRoutes } from './SignedOutRoutes.js'
import { SetupSignIn } from '../screens/signin/SetupSignIn.js'
import { AppRoutes } from './routes.js'

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
})

function Gate() {
  const { status } = useAuth()

  // Signed out, the app chrome is hidden entirely — sidebar, header and all.
  if (status === 'loading') return <div className="screen" style={{ padding: 'var(--space-8)' }} />
  // Signed in with only a password: add a passkey or authenticator first.
  if (status === 'setup-required') return <SetupSignIn />
  if (status !== 'signed-in') return <SignedOutRoutes />

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <Gate />
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
